import { render, staticRenderFns } from "./DictSortControl.vue?vue&type=template&id=76c8c58b&"
import script from "./DictSortControl.vue?vue&type=script&lang=js&"
export * from "./DictSortControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports